import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => (
  <div style={{ marginBottom: 28 }}>
    <h1
      style={{
        fontSize: 'clamp(1.4rem, 4vw, 1.8rem)',
        fontWeight: 800,
        letterSpacing: '-0.5px',
        lineHeight: 1.2,
      }}
    >
      {title}
    </h1>
    {subtitle && (
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginTop: 4 }}>
        {subtitle}
      </p>
    )}
  </div>
);

export const Highlight: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span
    style={{
      background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    }}
  >
    {children}
  </span>
);

export default PageHeader;
